import styles from './StoreCardSkeleton.module.scss'
import { Skeleton } from '@/tools/ui'

export const StoreCardSkeleton = () => (
  <Skeleton animated={true} className={styles.skeleton}>
    <svg
      className="pintxo-skeleton-shape"
      height="223"
      width="100%"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <rect height="160" rx="16" ry="16" width="100%" x="0" y="0" />
        <rect height="20" rx="10" ry="10" width="50%" x="0" y="168" />
        <rect height="20" rx="10" ry="10" width="30%" x="0" y="196" />
      </g>
    </svg>
  </Skeleton>
)
